import React from "react";
import { CWBDropdown } from "cwb-react";
import { withI18n } from "react-i18next";
import { withRouter } from "react-router-dom";
import styled, { css } from "styled-components";
import LegalSection from "common/LegalSection";
import * as SharedStyle from "common/SharedStyledComponents";
import Spinner from "images/spinner.svg";
import { getSupportEmail } from "shared/helpers";

import Button from "common/Button";
import CWBLabsFooter from "common/CWBLabsFooter";
import HorizontalDivider from "common/HorizontalDivider";
import Select from "common/Select";
import TextInput from "common/TextInput";
import Typography from "common/Typography";

const CWBForgotPwd = ({
  t,
  location,
  accounts,
  clientError,
  isLoading,
  selectedAccount,
  serverError,
  user,
  onChangeField,
  onChangeSelectedAccount,
  onKeyPress,
  onSubmit
}) => {
  return (
    <StyledDiv>
      <Card>
        <Typography align="center" component="h1" variant="h3">
          {t("Forgot Password")}
        </Typography>
        <HorizontalDivider />
        <Select
          error={Boolean(clientError && clientError.accountType)}
          errorMessage={clientError && clientError.accountType}
          label={t("Account Type")}
          options={accounts}
          placeholder={t("Select one")}
          value={selectedAccount}
          onSelect={onChangeSelectedAccount}
        />
        <TextInput
          error={Boolean(clientError && clientError.firstName)}
          errorMessage={clientError && clientError.firstName}
          label={t("First Name")}
          name="firstName"
          placeholder="Johnny"
          value={user.firstName}
          onChange={onChangeField}
          onKeyPress={onKeyPress}
        />
        <TextInput
          error={Boolean(clientError && clientError.email)}
          errorMessage={clientError && clientError.email}
          label={t("Email")}
          name="email"
          placeholder="example@example.com"
          value={user.email}
          onChange={onChangeField}
          onKeyPress={onKeyPress}
        />
        <StyledButton onClick={onSubmit}>
          {t("Submit")}
          {isLoading && <StyledImg src={Spinner} />}
        </StyledButton>
        {serverError && (
          <Typography color="error" component="span" variant="caption">
            {serverError.message}
          </Typography>
        )}
      </Card>
      <StyledTypography align="center" color="white" variant="h4">
        {t(
          "Your password reset link will be emailed to you. If you have any questions please contact our"
        )}
        &nbsp;
        <Link href={`mailto:${getSupportEmail}`}>
          {t("support team")}
        </Link>
        .
      </StyledTypography>
      <CWBLabsFooter />
    </StyledDiv>
  );
};

const StyledDiv = styled.div`
  width: 100%;
  height: calc(100vh - 80px);
  padding: 10vh 0;
  background-color: #040F1C;

  @media (max-width: 375px) {
    padding: 5vh 0;
  }
`;

const Card = styled.div`
  width: 400px;
  display: flex;
  flex-flow: column nowrap;
  margin: auto;
  padding: 24px 18px;
  background-color: #FFFFFF;
  border-top: 6px solid #02B8F9;
  border-radius: 4px;

  & > label {
    margin-top: 8px;
  }

  @media (max-width: 375px) {
    width: unset;
    margin: 0 16px;
  }
`;

const StyledButton = styled(Button)`
  margin-top: 24px;
  font-size: 14px;

  & + span {
    margin-top: 8px;
  }
`;

const StyledImg = styled.img`
  margin-left: 8px;
`;

const StyledTypography = styled(Typography)`
  max-width: 380px;
  margin: 16px auto 0;

  @media (max-width: 375px) {
    margin: 16px 16px 0;
  }
`;

const Link = styled.a`
  color: #FFFFFF;
  text-decoration: underline;

  &:hover {
    color: #FFFFFF;
  }
`;

export default withRouter(withI18n()(CWBForgotPwd));
